import type { ReactElement } from 'react'
import { WifiOffIcon } from './icons'
import styles from './OfflineNotice.module.css'

/**
 * Props for {@link OfflineNotice}.
 */
export interface OfflineNoticeProps {
  /** Notice text ("No connection — showing offline results"). */
  readonly text: string
}

/**
 * Inline offline notice shown in the `offline` state, directly above the
 * results (spec §4 / §15).
 *
 * Reuses the SectionHeader visual style — wifi-off icon + label, no
 * background strip — but is a sibling banner, not a `SuggestionSection`,
 * so it carries its own a11y id `suggester-offline-notice` (spec §8).
 */
export function OfflineNotice({ text }: OfflineNoticeProps): ReactElement {
  return (
    <div className={styles.notice} data-testid="suggester-offline-notice">
      <span className={styles.icon}>
        <WifiOffIcon />
      </span>
      <span className={styles.label}>{text}</span>
    </div>
  )
}
